export default __webpack_public_path__ + "static/media/Simao.c71b9661.png";